// extracted by mini-css-extract-plugin
export default {"container":"Projects_container__AGhJY","info":"Projects_info__IqlWq","cards":"Projects_cards__S2Da8","card":"Projects_card__-3Ufc","icon":"Projects_icon__fVoFk"};